// src/utils/smoothScroll.js
// ホイール操作を乗っ取って慣性スクロールにする（PC のみ）

const EASE = 0.075 // 小さいほど長く尾を引く（0.05〜0.12 が実用域）
const SPEED = 1.0 // 1ノッチで進む量。1 が標準、0.7 で控えめ

let target = 0
let current = 0
let running = false
let lastSelf = -1 // 自分が最後に書き込んだスクロール位置
let enabled = false

const maxScroll = () =>
  document.documentElement.scrollHeight - window.innerHeight

const clamp = v => Math.min(Math.max(v, 0), maxScroll())

function applyScroll(y) {
  window.scrollTo(0, y)
  lastSelf = window.scrollY // 端でクランプされた実値を控える
}

function loop() {
  if (!running) return

  const diff = target - current
  if (Math.abs(diff) < 0.5) {
    current = target
    applyScroll(current)
    running = false // 止まったら rAF を回さない
    return
  }

  current += diff * EASE
  applyScroll(current)
  requestAnimationFrame(loop)
}

function start() {
  if (!running) {
    running = true
    requestAnimationFrame(loop)
  }
}

function onWheel(e) {
  if (e.ctrlKey) return // ピンチズームは通す
  e.preventDefault()

  let delta = e.deltaY
  if (e.deltaMode === 1) delta *= 16 // 行単位（Firefox）
  else if (e.deltaMode === 2) delta *= window.innerHeight // ページ単位

  target = clamp(target + delta * SPEED)
  start()
}

function onScroll() {
  // 自前以外のスクロール（PageTop / react-scroll / キーボード / ページ遷移）を検知して譲る
  if (Math.abs(window.scrollY - lastSelf) > 2) {
    running = false
    target = current = window.scrollY
    lastSelf = window.scrollY
  }
}

function onResize() {
  target = clamp(target)
}

export function initSmoothScroll() {
  if (enabled) return
  // スマホはネイティブの慣性が優秀なので触らない。動きが苦手な人も除外
  if (window.matchMedia("(pointer: coarse)").matches) return
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

  target = current = lastSelf = window.scrollY
  enabled = true

  window.addEventListener("wheel", onWheel, { passive: false })
  window.addEventListener("scroll", onScroll, { passive: true })
  window.addEventListener("resize", onResize)
}

export function resetSmoothScroll() {
  if (!enabled) return
  running = false
  target = current = lastSelf = window.scrollY
}